<template>
  <div class="panda-service-features">
    <img
      class="top-img"
      src="../assets/imgs/panda-service-features/bg-服务1@2x.png"
    />
    <section>
      <img
        class="bg-img"
        src="../assets/imgs/panda-service-features/bg-服务2@2x.png"
      />
      <div class="content-box">
        <div class="item-box">
          <div class="title-box">
            <div class="title">拒签退全款</div>
            <img
              src="../assets/imgs/panda-service-features/img-拒签退全款@2x.png"
            />
          </div>
          <div class="content">
            签证申请存在拒签风险，熊猫签证为申请人提供签证保障。若申请人发生拒签，熊猫签证将按照拒签退款规则进行赔付，详细信息请查看<span
              class="red"
              @click="goToRefundExplain"
              >《拒签退款说明》</span
            >。
          </div>
        </div>
        <div class="item-box">
          <div class="title-box">
            <div class="title">智能签证照</div>
            <img
              src="../assets/imgs/panda-service-features/img-智能签证照@2x.png"
            />
          </div>
          <div class="content">
            手机拍摄一键智能生成签证照，智能完成人像抠图，根据签证要求自动匹配尺寸及底色，无需再跑照相馆。
          </div>
        </div>
        <div class="item-box">
          <div class="title-box">
            <div class="title">手机传资料</div>
            <img
              src="../assets/imgs/panda-service-features/img-手机传资料@2x.png"
            />
          </div>
          <div class="content">
            签证资料支持拍照上传，护照、身份证等证件均支持OCR信息识别，提交更便捷；
          </div>
          <div class="content">签证申请表支持手机在线填写，免去打印烦恼。</div>
        </div>
        <div class="item-box">
          <div class="title-box">
            <div class="title">专家预审核</div>
            <img
              src="../assets/imgs/panda-service-features/img-专家预审核@2x.png"
            />
          </div>
          <div class="content">
            平台经验丰富的签证专家，将对申请人的资料进行全方位审核，确保资料完善无误。同时针对资料问题提供资料改善建议，最大限度的降低您的拒签风险，提高签证的成功率。
          </div>
        </div>
        <div class="item-box">
          <div class="title-box">
            <div class="title">极速秒出签</div>
            <img
              src="../assets/imgs/panda-service-features/img-秒出签@2x.png"
            />
          </div>
          <div class="content">
            电子签全程在线审核办理，无需邮寄纸质材料。部分国家支持数据直连使馆，极速秒出签。
          </div>
          <div class="content">
            含邮寄环节的签证申请，资料预审核通过后，将第一时间送签使馆，无额外中转环节，确保最高效办签。
          </div>
        </div>
        <div class="item-box">
          <div class="title-box">
            <div class="title">数据强加密</div>
            <img
              src="../assets/imgs/panda-service-features/img-数据加密@2x.png"
            />
          </div>
          <div class="content">
            平台拥有国际认可的 ISO27001
            信息安全认证，拥有可靠的技术安全保障能力。数据采用AES高级加密，有效避免资料泄漏，保护用户隐私安全。
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import utils from '../services/tools.js';

export default {
  data() {
    return {
      sysConfigCoupon: {},
    };
  },
  created() {
    utils.setTitle('熊猫签证服务');
  },
  methods: {
    goToRefundExplain() {
      this.$router.push({ path: '/refundExplain' });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../styles/theme.less';

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.red {
  color: @red;
}

.panda-service-features {
  display: flex;
  flex-flow: column;
  align-items: center;
  .top-img {
    width: 100%;
  }
  section {
    display: flex;
    flex-flow: column;
    align-items: center;
    background-color: #333333;
    padding: 0 0.12rem 0.12rem 0.12rem;
    position: relative;
    img.bg-img {
      width: 100%;
      position: absolute;
      top: 0;
    }
    .content-box {
      background: #ffffff;
      padding: 0 0.24rem;
      position: relative;
      z-index: 1;

      .item-box {
        padding: 0.35rem 0 0.3rem 0;
        .title-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.24rem;
          .title {
            color: #333333;
            font-weight: 500;
            font-size: 0.24rem;
            line-height: 0.77rem;
            background: url('../assets/imgs/panda-service-features/形状结合@2x.png')
              no-repeat 0 0;
            background-size: 0.32rem 0.08rem;
          }
          img {
            width: 0.77rem;
            height: 0.77rem;
          }
        }
        .content {
          color: #686363;
          font-size: 0.14rem;
          line-height: 0.24rem;
        }
        &:nth-child(even) .title-box {
          flex-flow: row-reverse;
          .title {
            background-position: right 0;
          }
        }
      }
    }
  }
}
</style>
